var chunkMapping = {
	"63": [
		4063
	],
	"110": [
		2110
	],
	"260": [
		4260
	],
	"291": [
		2291
	],
	"293": [
		8293
	],
	"345": [
		9345
	],
	"356": [
		356
	],
	"363": [
		5363
	],
	"416": [
		1416
	],
	"431": [
		7431
	],
	"438": [
		4438
	],
	"543": [
		5543
	],
	"549": [
		549
	],
	"603": [
		1603
	],
	"620": [
		8620
	],
	"624": [
		624
	],
	"674": [
		5674
	],
	"718": [
		9718
	],
	"775": [
		4775
	],
	"787": [
		2787
	],
	"796": [
		1796
	],
	"811": [
		811
	],
	"834": [
		6834
	],
	"881": [
		3881
	],
	"888": [
		8888
	],
	"892": [
		6892
	],
	"928": [
		4928
	],
	"933": [
		4933
	],
	"975": [
		6975
	],
	"987": [
		8987
	]
};
var idToExternalAndNameMapping = {
	"356": [
		"default",
		"./TransfersM2MRequests",
		1909
	],
	"549": [
		"default",
		"./GlobalStore",
		7664
	],
	"624": [
		"default",
		"./TransfersBetweenAccounts",
		1480
	],
	"811": [
		"default",
		"./TransfersTemplates",
		6759
	],
	"1416": [
		"default",
		"./ChargeSuspenseLoader",
		9531
	],
	"1603": [
		"default",
		"./TransfersSuspenseLoader",
		9531
	],
	"1796": [
		"default",
		"./Slider",
		9018
	],
	"2110": [
		"default",
		"./TransfersPayments",
		3580
	],
	"2291": [
		"default",
		"./LocalizationDictionary",
		1602
	],
	"2787": [
		"default",
		"./FeesAndFines",
		5421
	],
	"3881": [
		"default",
		"./TransfersByRequisites",
		7128
	],
	"4063": [
		"default",
		"./TransferHomeAuto",
		6335
	],
	"4260": [
		"default",
		"./IntegrationHub",
		7910
	],
	"4438": [
		"default",
		"./ErrorBox",
		9018
	],
	"4775": [
		"default",
		"./BasicCellHeadline",
		9018
	],
	"4928": [
		"default",
		"./TransfersToRosbank",
		2682
	],
	"4933": [
		"default",
		"./NavBar",
		9018
	],
	"5363": [
		"default",
		"./Layout",
		9018
	],
	"5543": [
		"default",
		"./TransfersSBP",
		1655
	],
	"5674": [
		"default",
		"./hoc",
		9018
	],
	"6834": [
		"default",
		"./TransfersP2PSuspenseLoader",
		9531
	],
	"6892": [
		"default",
		"./TransfersP2P",
		6992
	],
	"6975": [
		"default",
		"./GlobalDataLoader",
		9101
	],
	"7431": [
		"default",
		"./Row",
		9018
	],
	"8293": [
		"default",
		"./SuspenseLoader",
		9531
	],
	"8620": [
		"default",
		"./TransfersM2M",
		5813
	],
	"8888": [
		"default",
		"./TransfersB2C",
		1751
	],
	"8987": [
		"default",
		"./FavoritesBlock",
		6759
	],
	"9345": [
		"default",
		"./TransfersQR",
		1772
	],
	"9718": [
		"default",
		"./ActionButton",
		9018
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}